/**
 * @author PengWen
 * @description 新能源组织迁移  业务数据的受众/管理范围调整
 * @Date 2023/03/20
 */
import {component_tool} from "../../../tool";

let {WizModal} = component_tool

let componentName = "bizDataMove"

const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: "业务类型名称",
    name: "businessName",
    searchItem: {},
    tableItem: {
      width: 200
    },
  },
  {
    title: "数据库表名",
    name: "tableName",
    tableItem: {
      width: 300
    },
  },
  {
    title: "最新受众范围修改时间",
    name: "normalUpdateTime",
    tableItem: {
      width: 300
    },
  },
  {
    title: "最新管理范围修改时间",
    name: "managerUpdateTime",
    tableItem: {
    },
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns,
      searchBarProps: {
        buttonSort: [],
        collapse: false,
        buttons: []
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        selectType: 'checkbox',
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort: ['bizDataList','operateRecordList','batchSet'],
      rowOperateView: [
        {
          key: "bizDataList",
          custom: true,
          params: { children: "查看业务数据详情"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/bizDataMove/bizList"
            }
          },
        },
        {
          key: "operateRecordList",
          custom: true,
          params: { children: "查看操作记录"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/bizDataMove/recordList"
            }
          },
        },
        {
          key: 'batchSet',
          custom: true,
          params: {
            children: '批量替换受众范围',
          },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/bizDataMove/bizDataMoveReplaceStudent"
            }
          }
        },
        {
          key: 'batchSet',
          custom: true,
          params: {
            children: '批量替换管理范围',
          },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/bizDataMove/bizDataMoveReplaceManager"
            }
          }
        },
        {
          key: 'batchSet',
          custom: true,
          params: {
            children: '批量新增受众范围',
          },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/bizDataMove/bizDataMoveAddStudent"
            }
          }
        },
        {
          key: 'batchSet',
          custom: true,
          params: {
            children: '批量新增管理范围',
          },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/bizDataMove/bizDataMoveAddManager"
            }
          }
        },
        {
          key: 'batchSet',
          custom: true,
          params: {
            children: '批量删除受众范围',
          },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/bizDataMove/bizDataMoveDeleteStudent"
            }
          }
        },
        {
          key: 'batchSet',
          custom: true,
          params: {
            children: '批量删除管理范围',
          },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/bizDataMove/bizDataMoveDeleteManager"
            }
          }
        },
      ],
      rowOperateProps: {
        width: 300,
        fixed: 'right',
      },
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/bizDataPageList`,
    payload: {
      key: `${componentName}@bizDataPageList`,
      apiParams: {}
    }
  },
}

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};